export const WITH_AUTH = true;
export const NO_AUTH = false;

export const statusCode = {
  success: 200,
  no_content: 204,
  invalid_input_error: 400,
  authentication_error: 401,
  access_denied_error: 403,
  not_found_error: 404,
  conflict_error: 409,
  validation_error: 422,
  unexpected_error: 500
};

export const USER_LOADED = 1;
export const USER_TASKS_LOADED = 2;
export const WALLET_MODAL_EVENT = 'wallet-modal-toggle';
